import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function PricingSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-206">
      <div className="text-center mb-12" data-id="element-207">
        <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-208">
          ELEGÍ TU MEGAPACK
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-209">
        {/* Basic Kit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy-800/50 border border-navy-600 rounded-3xl p-8 flex flex-col relative" data-id="element-210">
          <div className="mb-6" data-id="element-211">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-212">
              📘 MEGAPACK ANTI-CRISIS
            </h3>
            <p className="text-blue-200 text-sm font-medium mb-4" data-id="element-213">
              6 Tomos + 6 Bonos
            </p>
            <p className="text-blue-100/80 text-sm min-h-[40px]" data-id="element-214">
              Para familias que quieren ordenar el mes y dejar de improvisar en
              la cocina
            </p>
          </div>

          <div className="mb-8" data-id="element-215">
            <p className="text-gray-400 line-through text-lg mb-1" data-id="element-216">$89.000</p>
            <div className="flex items-baseline gap-2" data-id="element-217">
              <span className="text-4xl font-bold text-white" data-id="element-218">$17.990</span>
              <span className="text-xl text-blue-200" data-id="element-219">ARS</span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-220">
            <a href="https://www.mundorecursos.store/cart/45163580817487:1" className="block w-full py-4 px-6 bg-navy-700 hover:bg-navy-600 text-white font-bold text-center rounded-xl transition-colors border border-navy-500" data-id="element-221">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </motion.div>

        {/* Premium Kit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-b from-navy-800 to-navy-900 border-2 border-gold-500 rounded-3xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(212,168,83,0.15)] transform md:-translate-y-4" data-id="element-222">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold-500 text-navy-900 font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1 whitespace-nowrap shadow-lg" data-id="element-223">
            <Star className="w-4 h-4 fill-navy-900" data-id="element-224" /> MÁS ELEGIDO
          </div>

          <div className="mb-6 mt-2" data-id="element-225">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-226">
              🏆 MEGAPACK + LA CALCULADORA DE FUGAS{' '}
              <Star className="w-5 h-5 text-gold-400 fill-gold-400" data-id="element-227" />
            </h3>
            <p className="text-gold-400 text-sm font-medium mb-4" data-id="element-228">
              6 Tomos + 6 Bonos + La Calculadora de Fugas
            </p>
            <p className="text-blue-100/80 text-sm min-h-[40px]" data-id="element-229">
              Para familias que quieren detectar exactamente por dónde se les
              escapa la plata cada mes y cerrar esas fugas
            </p>
          </div>

          <div className="mb-8" data-id="element-230">
            <p className="text-gray-400 line-through text-lg mb-1" data-id="element-231">$119.000</p>
            <div className="flex items-baseline gap-2" data-id="element-232">
              <span className="text-5xl font-bold text-gold-400" data-id="element-233">$24.990</span>
              <span className="text-xl text-gold-400/80" data-id="element-234">ARS</span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-235">
            <a href="https://www.mundorecursos.store/cart/45163595038799:1" className="block w-full py-4 px-6 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-900 font-bold text-center rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-236">
              → QUIERO EL MEGAPACK + LA CALCULADORA DE FUGAS
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}